module.exports = __webpack_public_path__ + "static/open-source-test@2x-a9a6bcadb364dfd5b2802f89fb05869e.jpg";